import { render, staticRenderFns } from "./ParcelHelpers.vue?vue&type=template&id=963aba62&"
import script from "./ParcelHelpers.vue?vue&type=script&lang=js&"
export * from "./ParcelHelpers.vue?vue&type=script&lang=js&"
import style0 from "./ParcelHelpers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports